// eslint-disable-next-line no-unused-vars
import { SchemaJSON } from "../form/index.js";
// eslint-disable-next-line no-unused-vars
import { WidgetGridModel } from "./WidgetGrid.jsx";
export { AddWidgetModel };
/** 
 * Модель виджета добавления виджетов.
 */
class AddWidgetModel {
  /**
   * Заголовок диалога.
   * @type {string}
   */
  title = "Добавить виджет";
  /**
   * Модель `WidgetGrid`.
   * @type {WidgetGridModel}
   */
  widget_grid;
  /**
   * Локаль для перевода имён виджетов.
   * @type {Locale}
   */
  locale;
  /**
   * Состояние диалога: открыт (true) | закрыт (false).
   * @type {boolean}
   */
  open = false;
  /**
   * Открывает/закрывает диалог.
   * @param {Event | Object} _event - Событие.
   */
  // eslint-disable-next-line no-unused-vars
  onClick = event => { };
  /**
   * Отправляет запрос на сохранение.
   * @param {Object} data - Данные формы.
   */
  // eslint-disable-next-line no-unused-vars
  onSubmit = data => { };
  /**
   * @returns {SchemaJSON} Схема формы для диалога добавления вопроса.
   */
  getSchema = () =>
  ({
    properties: Object.fromEntries(this.widget_grid.grid
      .filter(cell => "AddWidget" != cell.id)
      .map(cell =>
        [
          cell.id,
          {
            title: this.locale.message(cell.id),
            type: "boolean",
            default: cell.visible
          }
        ])),
    actions:
      [
        {
          name: "Сохранить",
          type: "primary",
        },
        {
          name: "Отмена",
          onClick: this.onClick,
        },
      ],
    onSubmit: this.onSubmit
  });
  /**
   * Копирует свойства объекта.
   * @param {AddWidgetModel} props - Свойства объекта.
   */
  constructor(props) { Object.assign(this, props); }
}